import APIService from '../../../Services/APIService';
import { Apis } from '../../../Services/app.constants';
import { computeHasMore } from '../../../components/ui/SearchableSelect/selectUtils';
import { mapOrganisationToSelectOption } from '../utils/organisationSelectUtils';

function extractList(data) {
  if (Array.isArray(data)) return data;
  return data?.list ?? data?.results ?? [];
}

export async function fetchOrganisationListPage({ page, pageSize, search = '', signal }) {
  const query = encodeURIComponent(String(search ?? '').trim());
  const url = `${Apis.Get_Organisation_List}?next_page=${page}&search=${query}&limit=${pageSize}`;
  const res = await APIService.get(url, signal ? { signal } : {});

  if (res.status !== 200 && res.status !== 201) {
    throw new Error('Failed to load organisations');
  }

  const rawList = extractList(res.data);
  const items = rawList.map(mapOrganisationToSelectOption).filter(Boolean);
  const totalCount = res.data?.count ?? res.count ?? null;

  return {
    items,
    totalCount,
    hasMore: computeHasMore({
      page,
      pageSize,
      itemsLength: items.length,
      totalCount,
    }),
  };
}
